"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOpenClose = void 0;
var react_1 = require("react");
var useOpenClose = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.initialState, initialState = _c === void 0 ? false : _c;
    var _d = (0, react_1.useState)(initialState), isOpen = _d[0], setIsOpen = _d[1];
    var toggle = function () { return setIsOpen(!isOpen); };
    var close = function () { return setIsOpen(false); };
    var open = function () { return setIsOpen(true); };
    return { isOpen: isOpen, toggle: toggle, close: close, open: open };
};
exports.useOpenClose = useOpenClose;
//# sourceMappingURL=useOpenClose.js.map